import React, { useState, useCallback, useEffect } from "react";
import ItemGrid from "./ItemGrid";
import data from "../../../../assets/apiRoutes.json";
import axios from "axios";
import { connect } from "react-redux";
import LotGrid from "./LotGrid";
import SublotGrid from "./SublotGrid";
import LocationsPopUp from "./LocationsPopUp";
import InventoryItemStatusPopUp from "./InventoryItemStatusPopUp";
import InventorySerialNamberPopUp from "./InventorySerialNamberPopUp";
import LotHoldPopUp from "./LotHoldPopUp";
import ReportViewer from "../../../../reports/components/ReportViewer";
import Popup from 'devextreme-react/popup';
import { ABECASUSER_LOGIN_TYPE } from "../../../../common/permissions";
import AccordionReact from 'devextreme-react/accordion';
import "../../wmmodulestyle.css";
import Toolbar, { Item } from "devextreme-react/toolbar";
import { TextBox, DateBox, SelectBox, CheckBox, Button, } from 'devextreme-react';
import { createStore } from 'devextreme-aspnet-data-nojquery';
import { getAppSettings } from "../../../../common/Utils";

const searchpanel = [
  {
    ID: 1,
    Title: 'Search Filters'
  }
];

const lotDataGrid = React.createRef();
const InventorySearchForm = (props) => {
  var accessToken = props.oidc.user.access_token;
  const [searchPanelStatus, setSearchPanelStatus] = React.useState(getAppSettings()?.FiltersCollapsed? false : true);
  const selectionChanged = useCallback(
    (e) => {
      setSearchPanelStatus((prevStatus) => {
        const newStatus = !prevStatus;
        setSearchPanelStatus(newStatus);
      });
    },
    [searchPanelStatus],
  );

  const [stateItemObj, setStateItemObj] = useState({});
  const [stateLocPopUp, setstateLocPopUp] = useState(false);
  const [stateStatusPopUp, setStateStatusPopUp] = useState(false);
  const [stateSerialNumberPopUp, setstateSerialNumberPopUp] = useState(false);
  const [stateOnHoldPopUp, setStateOnHoldPopUp] = useState(false);
  const [stateOffHoldPopUp, setStateOffHoldPopUp] = useState(false);
  const [stateReportViewerPopUp, setStateReportViewerPopUp] = useState(false);
  const [reportViewerFileName, setReportViewerFileName] = useState("");
  const [isGeneratingReport, setIsGeneratingReport] = useState(false);
  const [locbtnDisable, setlocbtnDisable] = useState(true);
  const [statusbtnDisable, setStatusbtnDisable] = useState(true);
  const [SerialNumberBtnDisable, setSerialNumberBtnDisable] = useState(true);
  const [onHoldBtnDisable, setOnHoldBtnDisable] = useState(true);
  const [offHoldBtnDisable, setOffHoldBtnDisable] = useState(true);
  const [shouldLoadData, setShouldLoadData] = useState(false);

  const handleItemCallback = (ChildData) => {
    setStateItemObj(ChildData);
  };
  useEffect(() => {
    if (shouldLoadData) {
      loadInventoryItemData();
      setShouldLoadData(false);
    }
  }, [shouldLoadData]);
  const handleLotCallback = (ChildData) => {
    var data = new Object();
    data.itemCode = ChildData.itemCode
    data.lotRowid = ChildData.lotRowid;
    data.lotCode = ChildData.lotCode;
    data.lotDescription1 = ChildData.lotDescription1;
    data.lotDescription2 = ChildData.lotDescription2;
    data.lotStatus = ChildData.lotStatus;
    data.itemType = ChildData.itemType;
    setStateItemObj(data);
    setlocbtnDisable(false);
    setSerialNumberBtnDisable(false);
    setStatusbtnDisable(false);
    setOnHoldBtnDisable(false);
    setOffHoldBtnDisable(false);
  };

  const handleSublotCallback = (ChildData) => {
    axios
      .post(`${window._env_.REACT_APP_APIS}/${data.Item.GetItemByRowid}`, { itemRowid: ChildData.itemRowid },
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken,
            Authorization: `Bearer ${accessToken}`,
          },
        })
      .then((res) => {
        res.data.lotRowid = ChildData.lotRowid;
        res.data.subLotRowid = ChildData.subLotRowid;
        setStateItemObj(res.data);
        setlocbtnDisable(false);
        setSerialNumberBtnDisable(false);
        setStatusbtnDisable(false);
        setOnHoldBtnDisable(false);
      });
  };

  const handlEnableDisableLocBtn = (ChildData) => {
    setlocbtnDisable(ChildData);
  };
  const handlEnableDisableStatusBtn = (ChildData) => {
    setStatusbtnDisable(ChildData);
  };

  const handlEnableDisableSerialNumberBtn = (ChildData) => {
    setSerialNumberBtnDisable(ChildData);
  };

  const handleEnableDisableOnHoldBtn = (ChildData) => {
    setOnHoldBtnDisable(ChildData);
  };

  const handleEnableDisableOffHoldBtn = (ChildData) => {
    setOffHoldBtnDisable(ChildData);
  };

  const [inventoryItemCodesData, setinventoryItemCodesData] = useState([]);
  // Get initial value for netAvailableGreaterThanZero from settings
  const getInitialNetAvailableValue = () => {
    if (props.oidc?.user?.profile?.hasOwnProperty("WMINVENTORYITEMSNETAVAIL")) {
      return props.oidc.user.profile.WMINVENTORYITEMSNETAVAIL === 'Y';
    }
    return false;
  };
  const [inventoryItemCodesObj, setinventoryItemCodesObj] = useState({
    itemDescription1: "",
    lotDescription1: "",
    customerCode: "",
    lotCode: "",
    itemCode: "",
    sublotCode: "",
    sublotDescription1: "",
    netAvailableGreaterThanZero: getInitialNetAvailableValue()
  });
  const { itemDescription1, lotDescription1, customerCode, lotCode, itemCode, sublotCode, sublotDescription1, netAvailableGreaterThanZero } =
    inventoryItemCodesObj;

  const onInputChange = (name,e) => {
    setinventoryItemCodesObj((prevValue)=>({
      ...prevValue,
      [name]: e.value,
    }));
  };

  const onNetAvailableGreaterThanZeroChange = (e) => {
    setinventoryItemCodesObj({
      ...inventoryItemCodesObj,
      netAvailableGreaterThanZero: e.value,
    });
  };

  const resetItemSearcForm = (e) => {
    e.event.stopPropagation();
    setlocbtnDisable(true);
    setSerialNumberBtnDisable(true);
    setlocbtnDisable(true);
    setOnHoldBtnDisable(true);
    setOffHoldBtnDisable(true);

    setinventoryItemCodesObj({
      itemDescription1: "",
      lotDescription1: "",
      customerCode: "",
      lotCode: "",
      itemCode: "",
      sublotCode: "",
      sublotDescription1: "",
      netAvailableGreaterThanZero: getInitialNetAvailableValue()
    });
    setShouldLoadData(true);
  };
  const loadInventoryItemData = () => {
    var apiMethod = data.Item.GetAllItems;

    if (props.selectedTab === "Lot") {
      apiMethod = data.Lot.GetAllLots;

      if (lotDataGrid != null && lotDataGrid.current != null && lotDataGrid.current.instance != null) {
        lotDataGrid.current.instance().beginCustomLoading("Loading");
      }
    }
    else if (props.selectedTab === "Sublot") {
      apiMethod = data.SubLot.GetAllSubLots;
    }

    const resultData = createStore({
      key: 'rowId',
      loadParams:
      {
        itemDescription1: function () {
          return inventoryItemCodesObj.itemDescription1;
        },
        lotDescription1: function () {
          return inventoryItemCodesObj.lotDescription1;
        },
        lotCode: function () {
          return inventoryItemCodesObj.lotCode;
        },
        itemCode: function () {
          return inventoryItemCodesObj.itemCode;
        },
        customerCode: function () {
          return inventoryItemCodesObj.customerCode;
        },
        sublotCode: function () {
          return inventoryItemCodesObj.sublotCode;
        },
        sublotDescription1: function () {
          return inventoryItemCodesObj.sublotDescription1;
        },
        netAvailableGreaterThanZero: function () {
          return inventoryItemCodesObj.netAvailableGreaterThanZero;
        },
      },
      loadUrl: `${window._env_.REACT_APP_APIS}/${apiMethod}`,
      onBeforeSend: (method, ajaxOptions) => {
        ajaxOptions.headers = {
          access_token: accessToken,
          Authorization: `Bearer ${accessToken}`,
        };
      },
      paginate: true,
      pageSize: 100
    });
    setinventoryItemCodesData(resultData);
    if (props.selectedTab === "Lot" && lotDataGrid != null && lotDataGrid.current != null && lotDataGrid.current.instance != null) {
      lotDataGrid.current.instance().endCustomLoading();
    }
  };

  const onSubmit = async (e) => {
    e.event.stopPropagation();
    setStateItemObj({});
    setlocbtnDisable(true);
    setSerialNumberBtnDisable(true);
    setStatusbtnDisable(true);
    setOnHoldBtnDisable(true);
    setOffHoldBtnDisable(true);
    loadInventoryItemData();
  };
  useEffect(() => {
    const isLoadDataOnPageLoad = getAppSettings()?.LoadGridOnPageLoad ?? false;
    if (isLoadDataOnPageLoad) {
      loadInventoryItemData();
    }
  }, []);

  // Update netAvailableGreaterThanZero when setting changes
  useEffect(() => {
    if (props.oidc?.user?.profile?.hasOwnProperty("WMINVENTORYITEMSNETAVAIL")) {
      const shouldBeChecked = props.oidc.user.profile.WMINVENTORYITEMSNETAVAIL === 'Y';
      setinventoryItemCodesObj(prev => ({
        ...prev,
        netAvailableGreaterThanZero: shouldBeChecked
      }));
    }
  }, [props.oidc?.user]); // Watch the entire user object instead of just the nested property


  const handleClosePopUpCallback = (ChildData) => {
    setstateLocPopUp(ChildData);
  };
  const handleStatusPopUpCloseCallback = (ChildData) => {
    setStateStatusPopUp(ChildData);
  };
  const handleSerialNumberClosePopUpCallback = (ChildData) => {
    setstateSerialNumberPopUp(ChildData);
  };
  const handleOnHoldClosePopUpCallback = (ChildData) => {
    setStateOnHoldPopUp(false);
    if (ChildData) {
      loadInventoryItemData();
    }
  };

  const handleOffHoldClosePopUpCallback = (ChildData) => {
    setStateOffHoldPopUp(false);
    if (ChildData) {
      loadInventoryItemData();
    }
  };

  const openLocations = (e) => {
    if (stateItemObj) {
      setstateLocPopUp(true);
    }
  };
  const openSerialnumberPopUp = (e) => {
    if (stateItemObj) {
      setstateSerialNumberPopUp(true);
    }
  };
  const openStatus = (e) => {
    if (stateItemObj) {
      setStateStatusPopUp(true);
    }
  };

  const openOnHoldPopup = (e) => {
    if (stateItemObj) {
      setStateOnHoldPopUp(true);
    }
  };

  const openOffHoldPopup = (e) => {
    if (stateItemObj) {
      setStateOffHoldPopUp(true);
    }
  };

  const openReportViewerPopup = async (e) => {
    if (!stateItemObj || !stateItemObj.lotRowid) {
      window.alert("Please select a lot first");
      return;
    }

    setIsGeneratingReport(true);
    const accessToken = props.oidc.user.access_token;

    const report = {
      name: "WMR0047",
      fullName: "Argos.Report.WM.WMR0047, Argos.Report.WM",
      fileFormat: "PDF",
      ignoreFormat : true,
      parameterList: [
        {
          name: "Level",
          value: "Lot",
          parameterType: 5,
          label: "Level",
          mandatory: false
        },
        {
          name: "DatetoUse",
          value: "S",
          parameterType: 5,
          label: "Date to Use",
          mandatory: false
        },
        {
          name: "BeginDate",
          value: "1900/01/01 00:00:00",
          parameterType: 4,
          label: "Begin Date",
          mandatory: false
        },
        {
          name: "EndDate",
          value: (() => {
            const now = new Date();
            const year = now.getFullYear();
            const month = String(now.getMonth() + 1).padStart(2, '0');
            const day = String(now.getDate()).padStart(2, '0');
            return `${year}/${month}/${day} 00:00:00`;
          })(),
          parameterType: 4,
          label: "End Date",
          mandatory: false
        }
      ],
      filterWhereInfoList: [
        {
          fieldName: "Rowid",
          displayLabel: "Lot",
          from: stateItemObj.lotRowid,
          operation: 3,
          origin: "IMLOT.ROWID"
        }
      ]
    };

    try {
      const response = await axios.post(
        `${window._env_.REACT_APP_APIS}/${data.reports.GenerateReport}`,
        report,
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken,
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );

      setIsGeneratingReport(false);

      if (response.data && response.data.isSuccess && response.data.fileName) {
        setReportViewerFileName(`PDF:${response.data.fileName}`);
        setStateReportViewerPopUp(true);
      } else {
        window.alert("Cannot generate report. " + (response.data?.errorMessage || "Unknown error"));
      }
    } catch (error) {
      setIsGeneratingReport(false);
      window.alert("Error generating report: " + (error.message || error));
    }
  };

  const handleReportViewerClosePopup = (ChildData) => {
    setStateReportViewerPopUp(false);
    setReportViewerFileName("");
  };

  return (
    <div >
      <form>
        <div>

          <AccordionReact
            dataSource={searchpanel}
            collapsible={true}
            multiple={false}
            animationDuration={300}
            defaultSelectedIndex={getAppSettings()?.FiltersCollapsed ? -1 : 0}
            onSelectionChanged={selectionChanged}
            className="accordion-height"
            itemTitleRender={() => (
              <Toolbar className="accordian-toolbar">
                <Item location="before">
                  <div className="title">
                    <h6
                      style={{
                        color: window._env_.Color2
                      }}
                    >
                      Enter your Query For Inventory {props.selectedTab}s
                    </h6>
                  </div>
                </Item>
                <Item location="after">
                  <Button className="accordianButton" onClick={onSubmit} text="Search" type="default" />
                </Item>
                <Item location="after">
                  <Button className="accordianButton" onClick={resetItemSearcForm} text="Reset" />
                </Item>
              </Toolbar>

            )}
            itemRender={(itemProps) => (
              <>
                <div className="row">
                  <div className="col-md-3">
                    <TextBox
                      stylingMode='outlined'
                      labelMode="static"                      
                      label="Enter Item Code"
                      onValueChanged={(e) => onInputChange('itemCode',e)}
                      name="itemCode"
                      value={itemCode}                   
                      variant="outlined"
                    />
                  </div>
                  <div className="col-md-3">
                    <TextBox
                      stylingMode='outlined'
                      labelMode="static"                      
                      label="Enter Lot Code"
                      onValueChanged={(e) => onInputChange('lotCode',e)}
                      name="lotCode"
                      value={lotCode}                      
                      variant="outlined"
                      
                    />
                  </div>
                  <div className="col-md-3">
                    <TextBox
                      stylingMode='outlined'
                      labelMode="static"  
                      label="Enter Item Description"
                      onValueChanged={(e) => onInputChange('itemDescription1',e)}
                      name="itemDescription1"
                      value={itemDescription1}
                      variant="outlined"

                    />
                  </div>
                  <div className="col-md-3">
                    <TextBox
                      stylingMode='outlined'
                      labelMode="static"
                      label="Enter Lot Description"
                      onValueChanged={(e) => onInputChange('lotDescription1',e)}
                      name="lotDescription1"
                      value={lotDescription1}                     
                      variant="outlined"
                      
                    />
                  </div>
                </div>
                <div className="row accordianLastRow">
                  <div className="col-md-3">
                    <TextBox
                      stylingMode='outlined'
                      labelMode="static"    
                      label="Enter Sublot Code"
                      onValueChanged={(e) => onInputChange('sublotCode',e)}
                      name="sublotCode"
                      value={sublotCode}                     
                      variant="outlined"
                      
                    />
                  </div>
                  <div className="col-md-3">
                    <TextBox

                      stylingMode='outlined'
                      labelMode="static"
                      
                      label="Enter Sublot Description"
                      onValueChanged={(e) => onInputChange('sublotDescription1',e)}
                      name="sublotDescription1"
                      value={sublotDescription1}
                      
                      variant="outlined"
                      
                    />
                  </div>
                  <div className="col-md-3">
                    <CheckBox
                      className="accordianCheckbox"
                      onValueChanged={onNetAvailableGreaterThanZeroChange}
                      text="Net Available > 0"
                      value={netAvailableGreaterThanZero}
                    />
                  </div>
                  {props.oidc.user.profile.hasOwnProperty("LOGINTYPEID") && props.oidc.user.profile.LOGINTYPEID == ABECASUSER_LOGIN_TYPE ? (
                    <div className="col-md-3">
                      <TextBox

                        stylingMode='outlined'
                        labelMode="static"
                        
                        label="Customer Code"
                        onValueChanged={(e) => onInputChange('customerCode',e)}
                        name="customerCode"
                        value={customerCode}
                        
                        variant="outlined"
                        
                      />
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </>
            )}
            id="accordion-container"
          />
        </div>
      </form>
      {props.selectedTab === "Item" ? (
        <ItemGrid
          data={inventoryItemCodesData}
          accessToken={accessToken}
          parentCallback={handleItemCallback}
          enableDisableLocBtn={handlEnableDisableLocBtn}
          enableDisableSrlNumber={handlEnableDisableSerialNumberBtn}
          enableDisableStatusBtn={handlEnableDisableStatusBtn}
          openLocations={openLocations}
          locbtnDisable={locbtnDisable}
          SerialNumberBtnDisable={SerialNumberBtnDisable}
          openSerialnumberPopUp={openSerialnumberPopUp}
          statusbtnDisable={statusbtnDisable}
          openStatus={openStatus}
          searchPanelStatus={searchPanelStatus}
        />
      ) : props.selectedTab === "Lot" ? (
        <LotGrid data={inventoryItemCodesData}
          gridRef={lotDataGrid}
          accessToken={accessToken}
          parentCallback={handleLotCallback}
          enableDisableLocBtn={handlEnableDisableLocBtn}
          enableDisableSrlNumber={handlEnableDisableSerialNumberBtn}
          enableDisableStatusBtn={handlEnableDisableStatusBtn}
          enableDisbaleOnHoldBtn={handleEnableDisableOnHoldBtn}
          enableDisableOffHoldBtn={handleEnableDisableOffHoldBtn}
          openLocations={openLocations}
          locbtnDisable={locbtnDisable}
          SerialNumberBtnDisable={SerialNumberBtnDisable}
          OnHoldBtnDisable={onHoldBtnDisable}
          OffHoldBtnDisable={offHoldBtnDisable}
          openSerialnumberPopUp={openSerialnumberPopUp}
          statusbtnDisable={statusbtnDisable}
          openStatus={openStatus}
          searchPanelStatus={searchPanelStatus}
          openOnHoldPopup={openOnHoldPopup}
          openOffHoldPopup={openOffHoldPopup}
          openReportViewerPopup={openReportViewerPopup}
        />
      ) : props.selectedTab === "Sublot" ? (
        <SublotGrid data={inventoryItemCodesData}
          accessToken={accessToken}
          parentCallback={handleSublotCallback}
          enableDisableLocBtn={handlEnableDisableLocBtn}
          enableDisableSrlNumber={handlEnableDisableSerialNumberBtn}
          enableDisableStatusBtn={handlEnableDisableStatusBtn}
          openLocations={openLocations}
          locbtnDisable={locbtnDisable}
          SerialNumberBtnDisable={SerialNumberBtnDisable}
          openSerialnumberPopUp={openSerialnumberPopUp}
          statusbtnDisable={statusbtnDisable}
          openStatus={openStatus}
          searchPanelStatus={searchPanelStatus}
        />
      ) : ("")
      }
      {stateLocPopUp && (
        <LocationsPopUp
          itemObj={stateItemObj}
          visibility={stateLocPopUp}
          parentCallback={handleClosePopUpCallback}
        ></LocationsPopUp>
      )}
      {stateSerialNumberPopUp && (
        <InventorySerialNamberPopUp
          itemObj={stateItemObj}
          visibility={stateSerialNumberPopUp}
          parentCallback={handleSerialNumberClosePopUpCallback}
        ></InventorySerialNamberPopUp>
      )}
      {stateStatusPopUp && (
        <InventoryItemStatusPopUp
          itemObj={stateItemObj}
          visibility={stateStatusPopUp}
          parentCallback={handleStatusPopUpCloseCallback}
        ></InventoryItemStatusPopUp>
      )}
      {stateOnHoldPopUp && (
        <LotHoldPopUp
          mode="on"
          itemObj={stateItemObj}
          visibility={stateOnHoldPopUp}
          parentCallback={handleOnHoldClosePopUpCallback}
        ></LotHoldPopUp>
      )}
      {stateOffHoldPopUp && (
        <LotHoldPopUp
          mode="off"
          itemObj={stateItemObj}
          visibility={stateOffHoldPopUp}
          parentCallback={handleOffHoldClosePopUpCallback}
        ></LotHoldPopUp>
      )}
      {stateReportViewerPopUp && reportViewerFileName && (
        <Popup
          visible={stateReportViewerPopUp}
          onHiding={handleReportViewerClosePopup}
          dragEnabled={true}
          hideOnOutsideClick={true}
          showCloseButton={true}
          showTitle={true}
          title="Lot History Report"
          container="#root"
          width="95%"
          height="95%"
        >
          <div style={{ height: "100%", width: "100%" }}>
            <ReportViewer reportName={reportViewerFileName} />
          </div>
        </Popup>
      )}
      {isGeneratingReport && (
        <Popup
          visible={isGeneratingReport}
          dragEnabled={false}
          showCloseButton={false}
          showTitle={false}
          width={300}
          height={150}
        >
          <div style={{ padding: "20px", textAlign: "center" }}>
            <p>Generating report...</p>
            <p>Please wait...</p>
          </div>
        </Popup>
      )}
    </div>
  );
};
function mapStateToProps(state) {
  return {
    ReceiptReducer: state.ReceiptReducer,
    oidc: state.oidc,
  };
}
export default connect(mapStateToProps)(InventorySearchForm);
